import { PolicyStatus } from '@insurance/api/requests'
import { Tag, TagProps } from 'antd'
import { useTranslation } from 'react-i18next'

type Props = {
  status?: PolicyStatus
}

const statusColors: Record<PolicyStatus, TagProps['color']> = {
  [PolicyStatus.ACTIVE]: 'success',
  [PolicyStatus.CANCELED]: 'error',
  [PolicyStatus.TERMINATED]: 'magenta-inverse',
  [PolicyStatus.PENDING]: 'magenta',
  [PolicyStatus.REVISED]: 'gold',
  [PolicyStatus.EXPIRED]: 'yellow-inverse'
}

export const PolicyStatusTag = ({ status }: Props) => {
  const { t } = useTranslation()

  if (!status) return null

  return <Tag color={statusColors[status]}>{t(status)}</Tag>
}
